<template>
	<div class="headerBody">
		<div class="headerChPc">
			<div class="headerFavicon" @click="reIndex()">
				<el-image id="headerFaviconImage" src="../static/favicon.png">
				</el-image>
			</div>
			<div class="headerNav">
				<el-header>
					<el-menu @select="handleSelect" router :default-active="$route.path" mode="horizontal">
						<el-menu-item index="/">数据概览</el-menu-item>
						<el-menu-item index="/monitor">数据监测计划</el-menu-item>
						<el-menu-item index="/calendar">热点日历</el-menu-item>
						<el-menu-item index="/dataDown">数据下载中心</el-menu-item>
						<el-menu-item index="/contribution">微博贡献人</el-menu-item>
						<el-menu-item index="/laboratory">实验室</el-menu-item>
						<el-menu-item index="/user">个人中心</el-menu-item>
					</el-menu>
				</el-header>
			</div>
			<div style="margin-right: 30px;padding-top: 10px;">
				<el-dropdown v-if="isLogin" style="display: flex;">
					<div>
						<el-avatar :src="avatar"></el-avatar>
					</div>
					<div><i style="text-align: center;padding-top: 100%;" class="el-icon-arrow-down el-icon--right"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="gotoUser()">个人中心</el-dropdown-item>
						<el-dropdown-item @click.native="logout()">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div v-if="!isLogin" style="margin-top: 12px;">
					<el-link @click="goLogin()" type="primary"><i class="el-icon-user"></i>登录/注册</el-link>
				</div>
			</div>
		</div>
		<div class="headerMobile">
			<div style="height: 50px;background-color: indianred;">
				<div style="display: flex;">
					<div
						style="flex: 50%;line-height: 50px;text-align: left;padding-left: 5%;font-weight: bold;color: aliceblue;">
						热搜引擎</div>
					<div style="padding-right: 5%;padding-top: 1.3%;">
						<el-dropdown v-if="isLogin" style="display: flex;color: aliceblue;">
							<el-avatar :src="avatar"></el-avatar>
							<div><i style="text-align: center;padding-top: 100%;"
									class="el-icon-arrow-down el-icon--right"></i></div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="gotoUser()">个人中心</el-dropdown-item>
								<el-dropdown-item @click.native="logout()">退出</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<div v-if="!isLogin" style="line-height: 40px;color: aliceblue;">
							<el-link style="color: aliceblue;" @click="goLogin()">登录/注册</el-link>
						</div>
					</div>
				</div>
				<div id="mobileMenu" style="margin: 10px;height: 80px;font-size: 15px;">
					<el-card class="box-card" style="height: 100%;">
						<div class="innerDiv" style="display: flex;flex-wrap: wrap;">
							<div style="width: 20%;">
								<router-link to="/">
									<el-button type="danger" circle>数据<br />概览</el-button>
								</router-link>
							</div>
							<div style="width: 20%;">
								<router-link to="/monitor">
									<el-button type="info" circle>数据<br />监测</el-button>
								</router-link>
							</div>
							<div style="width: 20%;">
								<router-link to="/calendar">
									<el-button type="primary" circle>热点<br />日历</el-button>
								</router-link>
							</div>
							<div style="width: 20%;">
								<router-link to="/dataDown">
									<el-button type="success" circle>下载<br />中心</el-button>
								</router-link>
							</div>
							<div style="width: 20%;">
								<el-button @click="goPcInfo()" type="warning" circle>更多<br />功能</el-button>
							</div>
						</div>
					</el-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		info,
		getAvatar
	} from "../api/user.js";
	import {
		fnRemoveToken
	} from '../util/auth.js';
	export default {
		data() {
			return {
				circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				activeIndex: '1',
				avatar: null
			};
		},
		created() {
			this.getAvatarInfo()
			this.getInfo()
		},
		computed: {
			isLogin() {
				this.getInfo()
				return this.$store.state.login
			}
		},
		methods: {
			goPcInfo(){
				this.$message("更多功能请前往PC端体验")
			},
			reIndex() {
				this.$router.go(0);
			},
			getAvatarInfo() {
				var that = this;
				getAvatar().then(res => {
					that.avatar = "https://api.multiavatar.com/" + res.data.data + ".png"
				}).catch((err) => {
					console.log(err)
				})
			},
			logout() {
				var that = this;
				fnRemoveToken()
				that.$store.commit("doLogout");
				that.goLogin()
			},
			getInfo() {
				var that = this;
				info().then(res => {
					if (res.data.code === 1 && res.data.data != null) {
						that.$store.commit("doLogin");
					} else {
						fnRemoveToken()
						that.$store.commit("doLogout");
					}
				}).catch((err) => {
					console.log(err)
				})
			},
			goLogin() {
				this.$router.push("/login", () => {}, () => {})
			},
			gotoUser() {
				this.$router.push("/user", () => {}, () => {})
			},
			handleSelect(key) {
				this.$router.push(key, () => {}, () => {})
			}
		}
	}
</script>

<style>
	@media (max-width: 768px) {
		.headerChPc {
			display: none !important;
		}
	}

	@media (min-width: 769px) {
		.headerMobile {
			display: none !important;
		}
	}

	.headerBody {
		background-color: white;
	}

	.headerBody .headerChPc {
		display: flex;
		width: 80%;
		margin: 0 auto;
		margin-bottom: 5px;
	}

	.headerBody .headerChPc .headerFavicon {
		margin-left: 30px;
	}

	.headerBody .headerChPc .headerFavicon .headerFaviconImage {
		height: 50px;
		margin-top: 10px;
	}

	.headerNav {
		flex: auto;
		font-weight: bold;
	}

	.el-menu.el-menu--horizontal {
		border-bottom: 0px !important;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.el-image__error,
	.el-image__inner,
	.el-image__placeholder {
		height: 80% !important;
	}
</style>